module.exports = __webpack_public_path__ + "img/2-2-1.f4ad98e2.png";